module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_add-to-unscopables.js
// module id = 1995
// module chunks = 2